<script setup>
import { defineProps} from "vue";
import NotaFiscalService from "../../../../../api/v2/services/NotaFiscalService";
import UtilMoney from "../../../../../utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
    "pagamento",
]);

//==================================================================//
//==================== get Nota Fiscal Recebida ====================//
//==================================================================//

const getNotaFiscalRecebida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.dado?.notaFiscalRecebidaChaveAcesso,
        plugNotasId: props?.dado?.notaFiscalRecebidaPlugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

</script>

<template>

    <div class="c-table__row">

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cash-multiple
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >
                        {{props?.pagamento?.sequencia}}
                    </span>
                    

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.status}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="props?.pagamento?.notaFiscalRecebidaID"
                            class="c-botao-nota-fiscal-recebida mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="props?.controlesDesativados"
                            @click="getNotaFiscalRecebida"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar Nota Fiscal Recebida</span>

                </v-tooltip>

                {{props?.pagamento?.notaFiscalRecebidaNumero}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.dataCriacao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.dataVencimento}}

            </div>

        </div>

         <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorDesconto)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorPagamento)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorReservado)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorParaPagar)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorParaVincular)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorVinculado)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #f0f0f0;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-nota-fiscal-recebida{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

</style>
